import React from "react";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { axiosInstance } from "../core/axios-interceptors";

interface DownloadButtonProps {
  fileUrl: string;
  fileName?: string;
}

const DownloadButton: React.FC<DownloadButtonProps> = ({
  fileUrl,
  fileName = "file",
}) => {
  const handleDownload = async () => {
    try {
      const response = await axiosInstance.get(fileUrl, {
        responseType: "blob",
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Errore durante il download:", error);
    }
  };

  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<DownloadIcon />}
      onClick={(event) => {
        event.stopPropagation();
        handleDownload();
      }}
    >
      Download
    </Button>
  );
};

export default DownloadButton;
